const formatNumber = (value: any, defaultZero: boolean = false, mode: string = "currency") => {
    /*
    * [How to use]
    *     {{ value | number( defaultZero , mode ) }}
    * [Example]
    *     defaultZero : false
    *     mode : [
    *          { digit : 1.0 }, 
    *          { currency : 1,000 },
    *         ]
    */
    let numericValue;
    if (value) {
        if (typeof (value) != "string") {
            value = value.toString();
        }
        numericValue = value
            .replace(/[^-.[0-9]/g, "")
            .replace(/(?!^)-/g, "");

        if (mode === 'digit') {
            numericValue = (Math.round(+numericValue.replace(/(\..*)\./g, "$1") * 100) / 100)
                .toFixed(1);
        } else if (mode === "currency") {
            numericValue = numericValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }

        return numericValue;
    }
    return defaultZero ? 0 : value;
};

export default formatNumber;
